import {Component, OnDestroy, ViewChild} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';

/*Services */
import { ObjectsService } from '@services/http/objects.service';
import { StateService } from '@services/state.service';

/*Models*/
import { ObservableObject } from '@models/observable-object';


/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';
import {ScreenService} from "@services";
declare var swal: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'confirm-deleting-modal',
  templateUrl: './confirm-deleting-modal.component.html'
})

export class ConfirmDeletingModalComponent implements OnDestroy {
  ngOnDestroy(): void {

    }

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  @ViewChild('confirmDeletingModal') dialog: BsModalComponent;


  errorMessage;
  observableObject: ObservableObject;
  btnText: any = {
    text: 'Обновить',
    defaultText: 'Обновить',
    loadText: 'Обработка..'
  };
  trySend = false;

  constructor(
    private objectsService: ObjectsService,
    private stateService: StateService,
    private screenService: ScreenService,
  ) {
  }

  confirm(result) {
    this.dialog.close(result);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/modal/confirm-deleting-modal/confirm-deleting-modal.component.ts